import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

interface TreasuryUiContextType {
  isTxWidgetsExpanded: boolean;
  setIsTxWidgetsExpanded: Dispatch<SetStateAction<boolean>>;
}

const TreasuryUiContext = createContext<TreasuryUiContextType>(null);

export default function TreasuryUiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isTxWidgetsExpanded, setIsTxWidgetsExpanded] = useState(false);

  return (
    <TreasuryUiContext.Provider
      value={{ isTxWidgetsExpanded, setIsTxWidgetsExpanded }}
    >
      {children}
    </TreasuryUiContext.Provider>
  );
}

export const useTreasuryUiContext = () => {
  const context = useContext(TreasuryUiContext);
  if (!context) {
    throw new Error(
      "useTreasuryUiContext must be used within a TreasuryUiProvider"
    );
  }
  return context;
};
